module.exports = __webpack_public_path__ + "static/media/superuser-inactive.847c6058.svg";